import { Controller } from "@hotwired/stimulus"

// Environment form: suggests a schema name from the environment name until the schema
// is edited directly, and shows the owner field for private environments.
export default class extends Controller {
  static targets = ["name", "schema", "type", "ownerGroup"]

  connect() {
    this.schemaTouched = this.hasSchemaTarget && this.schemaTarget.value.length > 0
  }

  nameChanged() {
    if (!this.hasSchemaTarget || this.schemaTouched) return
    this.schemaTarget.value = this.toSchema(this.nameTarget.value)
  }

  schemaEdited() {
    this.schemaTouched = this.schemaTarget.value.length > 0
  }

  typeChanged() {
    if (!this.hasOwnerGroupTarget) return
    this.ownerGroupTarget.classList.toggle("hidden", this.typeTarget.value !== "private")
  }

  toSchema(value) {
    let schema = (value || "").trim().toLowerCase().replace(/[^a-z0-9_]+/g, "_").replace(/_{2,}/g, "_")
    if (schema && !schema.match(/^[a-z_]/)) schema = `_${schema}`
    return schema.slice(0, 63)
  }
}
